import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/authContext/authContext";

export const PrivateRoute = ({ children }) => {
  const { user } = useContext(AuthContext);
  const { pathname } = useLocation();

  localStorage.setItem("lastPath", pathname);

  return user.name ? children : <Navigate to="/login" />;
};
